<template>
  <div>
    <HeaderBar />
    <div class="program-header">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
          <div id="program-menu" class="mr-auto">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#topnav-collapse" aria-controls="topnav-collapse" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
              <span class="navbar-toggle-label">Menu</span>
            </button>
          </div>
          <div class="collapse navbar-collapse" id="topnav-collapse">
            <ul class="navbar-nav">
              <li data-topnav="link1" class="nav-item"><router-link to="/" class="text-decoration-none nav-link" exact-active-class="active">Home</router-link></li>
              <li data-topnav="link2" class="nav-item"><router-link to="/dashboard" class="text-decoration-none nav-link" exact-active-class="active">Fleet DNA</router-link></li>
              <li data-topnav="link3" class="nav-item"><router-link to="/action-plan" class="text-decoration-none nav-link" exact-active-class="active">Action Plan</router-link></li>
              <li data-topnav="link4" class="nav-item"><router-link to="/resources" class="text-decoration-none nav-link" exact-active-class="active">Resources</router-link></li>
              <li data-topnav="link4" class="nav-item"><router-link to="/insights" class="text-decoration-none nav-link" exact-active-class="active">Insights</router-link></li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
import HeaderBar from './HeaderBar.vue';
</script>
